export default "__VITE_ASSET__DADcD3fz__"